export const flarelaneEventKeys = {
  pvm_pdp_inquiry_button_click: 'pvm_pdp_inquiry_button_click',
  pvm_sell_tractor_complete: 'pvm_sell_tractor_complete',
  pvm_sell_tractor_incomplete: 'pvm_sell_tractor_incomplete',
  pvm_fail_bump: 'pvm_fail_bump',
};
